import { render, staticRenderFns } from "./BackgroundSelector.vue?vue&type=template&id=33522389&scoped=true"
import script from "./BackgroundSelector.vue?vue&type=script&lang=js"
export * from "./BackgroundSelector.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSelector.vue?vue&type=style&index=0&id=33522389&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33522389",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33522389')) {
      api.createRecord('33522389', component.options)
    } else {
      api.reload('33522389', component.options)
    }
    module.hot.accept("./BackgroundSelector.vue?vue&type=template&id=33522389&scoped=true", function () {
      api.rerender('33522389', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/panelStyle/BackgroundSelector.vue"
export default component.exports